module.exports = __webpack_public_path__ + "img/conocenos3.68c197ab.webp";